/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Delete_Stage_EmptyInputs */

const cs_pipelines_delete_stage_empty = /** @type {(inputs: Pipelines_Delete_Stage_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat tuto fázi?`)
};

const en_pipelines_delete_stage_empty = /** @type {(inputs: Pipelines_Delete_Stage_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this stage?`)
};

/**
* | output |
* | --- |
* | "Delete this stage?" |
*
* @param {Pipelines_Delete_Stage_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_delete_stage_empty = /** @type {((inputs?: Pipelines_Delete_Stage_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Delete_Stage_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_delete_stage_empty(inputs)
	return cs_pipelines_delete_stage_empty(inputs)
});